import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { Observable } from "rxjs/Observable";

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';
import 'rxjs/add/operator/catch';

import * as globalConst from './../../../../constants';

@Injectable()
export class ReasonOfAllowanceEditService {

	private apiUrl = globalConst.baseAPI;

	constructor(private http: Http) {
	}

	loadReasonOfAllowance(token, ID) {
		return this.http
		.get(this.apiUrl + "motivoabono/v1/consultarmotivoabono/" + ID, JSON.parse(localStorage.getItem('yara.connectionHeader')))
		.map((res: Response) => res.json())
		.catch(e => {
			if (e.status === 401) {
				return Observable.throw('Unauthorized');
			}
		});
	}

	editReasonOfAllowance(token, reasonOfAllowance: any) {
		return this.http
		.put(this.apiUrl + "motivoabono/v1/atualizarmotivoabono", reasonOfAllowance, JSON.parse(localStorage.getItem('yara.connectionHeader')))
		.map((res: Response) => res.json())
		.catch(e => {
			if (e.status === 401) {
				return Observable.throw('Unauthorized');
			}
		});
	}

}



// WEBPACK FOOTER //
// ./src/app/reason-of-allowance/service/reason-of-allowance-edit/reason-of-allowance-edit.service.ts